<template>
  <v-card flat>
    <v-card-text class="px-4 pt-0">
      <div class="d-flex justify-end">
        <v-btn
          v-if="personData.userId == currentUser.id && showAddBioBtn"
          class="btn-bg"
          elevation="0"
          small
          @click="addTimelineModal()"
          ><v-icon left>mdi-plus</v-icon>{{ lang.actions.addEvent }}</v-btn
        >
      </div>
    </v-card-text>
    <v-card-text>
      <v-timeline align-top dense v-if="biographies.length" id="timeline">
        <v-timeline-item
          class="mb-12"
          color="primary"
          small
          v-for="(bio, index) in biographies"
          :key="index"
        >
          <v-row class="pt-0 mt-0">
            <v-col
              class="col-12 col-sm-4 col-md-3 on-mobile subtitle-1 pl-m0 pt-0"
            >
              <strong>{{ getStartEndDates(bio.from, bio.to) }}</strong>
            </v-col>
            <v-col
              class="col-12 col-sm-8 col-md-9 d-flex justify-space-between pl-m0"
            >
              <div>
                <h4 class="bio-title">{{ bio.title }}</h4>
                <div v-if="bio.description">
                  <p class="bio-text">{{ bio.description }}</p>
                </div>
                <div class="d-flex flex-wrap align-center mt-2">
                  <div v-for="(asset, ind) in bio.assets" :key="ind + '_asset'">
                    <img
                      v-if="asset.type == 1"
                      style="
                        width: 150px;
                        height: auto !important;
                        border-radius: 8px;
                      "
                      class="mr-2 mb-2"
                      :src="asset.url"
                      alt="Asset"
                      :lazy-src="
                        require('../../assets/images/lazy-loading.png')
                      "
                    />
                    <video
                      controlsList="nodownload"
                      style="width: 170px"
                      v-else-if="asset.type == 2 && asset.url"
                      controls
                      :key="asset.url"
                      :src="asset.url"
                      class="mr-2 mb-2"
                    >
                      <source :src="asset.url" type="video/mp4" />
                      <source :src="asset.url" type="video/webm" />
                      <source :src="asset.url" type="video/ogg" />
                      <source :src="asset.url" type="video/quicktime" />
                      <source :src="asset.url" type="video/x-msvideo" />
                      <source :src="asset.url" type="video/x-matroska" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                </div>
              </div>
              <div
                v-if="personData.userId == currentUser.id"
                class="ml-4 timeline-action-container"
              >
                <v-btn
                  elevation="0"
                  text
                  icon
                  outlined
                  color="primary"
                  @click="editTimelineModal(bio)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  elevation="0"
                  text
                  icon
                  outlined
                  color="primary"
                  @click="deleteTimelineModal(bio)"
                >
                  <v-icon>mdi-trash-can</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-timeline-item>
      </v-timeline>
      <NoResult
        v-else
        class="mt-0"
        :show="true"
        :title="lang.profile.noData"
      ></NoResult>
    </v-card-text>
    <v-dialog
      class="rounded-xl"
      v-model="dialogEditAdd"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title class="px-3">
          <span class="gc-text-h6">{{
            currentBio.id
              ? lang.profile.editBiography
              : lang.profile.addBiography
          }}</span>
        </v-card-title>
        <v-card-text class="px-0">
          <v-container class="px-0">
            <v-form ref="formTimeline" class="px-2">
              <v-row class="mx-0">
                <v-col cols="12" md="6" class="custom-input">
                  <div class="input-group">
                    <label>{{ lang.fields.startDate }} *</label>
                    <v-dialog
                      ref="dialogStart"
                      v-model="modalStart"
                      :return-value.sync="currentBio.from"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="currentBio.from"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          hide-details
                          outlined
                          v-bind="attrs"
                          dense
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="currentBio.from" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modalStart = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.dialogStart.save(currentBio.from)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </div>
                </v-col>
                <v-col cols="12" md="6" class="custom-input">
                  <div class="input-group">
                    <label>{{ lang.fields.endDate }}</label>
                    <v-dialog
                      ref="dialogEnd"
                      v-model="modalEnd"
                      :return-value.sync="currentBio.to"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="currentBio.to"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          hide-details
                          outlined
                          v-bind="attrs"
                          dense
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="currentBio.to" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modalEnd = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.dialogEnd.save(currentBio.to)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="input-group">
                    <label>{{ lang.fields.title }} *</label>
                    <input type="text" v-model="currentBio.title" />
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="input-group">
                    <label>{{ lang.fields.description }}</label>
                    <textarea
                      v-model="currentBio.description"
                      rows="4"
                    ></textarea>
                  </div>
                </v-col>
                <v-col cols="12" v-if="showMediaBio != 'Text only' && images.length">
                  <v-btn
                    @click="addMedia()"
                    class="btn-bg mb-4"
                    elevation="0"
                    small
                    ><v-icon left>mdi-image-plus</v-icon
                    >{{ lang.actions.addMedia }}</v-btn
                  >
                  <div
                    class="d-flex justify-space-between align-end mb-2"
                    v-for="(image, index) in currentBio.assets"
                    :key="index"
                  >
                    <div class="input-group" style="width: 100%" v-if="images.length">
                      <label>{{ lang.fields.selectMedia }}</label>
                      <select
                        v-model="currentBio.assets[index].value"
                        class="custom-select"
                      >
                        <option
                          v-for="(img, ind) in images"
                          :key="'img' + ind"
                          :value="img.value"
                        >
                          {{ img.text }}
                        </option>
                      </select>
                    </div>
                    <v-icon
                      class="primary--text ml-2 mb-2"
                      @click="removeImage(index)"
                      >mdi-trash-can-outline</v-icon
                    >
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="px-3">
          <v-spacer></v-spacer>
          <v-btn
            class="primary--text"
            elevation="0"
            text
            small
            @click="closeTimelineModal()"
          >
            {{ lang.actions.close }}
          </v-btn>
          <v-btn class="btn-bg" elevation="0" small @click="manageTimeline()">
            {{ lang.actions.save }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" persistent max-width="400">
      <v-card>
        <v-card-title class="gc-text-h6">
          {{ lang.actions.delete }}
        </v-card-title>
        <v-card-text>{{ lang.profile.w6 }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            elevation="0"
            small
            class="primary--text"
            @click="dialogDelete = false"
          >
            {{ lang.actions.cancel }}
          </v-btn>
          <v-btn
            small
            class="ml-2 btn-bg"
            elevation="0"
            @click="deleteTimeline()"
          >
            {{ lang.actions.delete }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import NoResult from "../../components/noResult";
export default {
  data() {
    return {
      modalStart: false,
      modalEnd: false,
      timelineMode: "",
      dialogEditAdd: false,
      dialogDelete: false,
      currentBio: {
        id: null,
        personId: "",
        userId: "",
        from: "",
        to: "",
        title: "",
        description: "",
        assets: [],
      },
      dateStartMenu: null,
      dateEndMenu: null,
      activePickerStart: null,
      activePickerEnd: null,
    };
  },
  components: {
    NoResult,
  },
  computed: {
    ...mapGetters(["rules"]),
    ...mapGetters("person", ["personMedia"]),
    lang() {
      return this.$store.state.langObj || {};
    },
    images() {
      return [{
        value: 1,
            text: 'First_school_day.png',
            type: 1,
            assetName: 'First_school_day.png',
      },
      {
        value: 2,
        text: 'bike_ride.mp4',
        type: 2,
        assetName: 'bike_ride.mp4',
      }]
      if (this.showMediaBio == "Text only") {
        return [];
      } else if (this.showMediaBio == "Text and images") {
        return this.personMedia
          .filter((el) => el.type == 1)
          .map((el) => {
            return {
              value: el.id,
              text: el.name,
              type: el.type,
              assetName: el.name,
            };
          });
      } else {
        return this.personMedia.map((el) => {
          return {
            value: el.id,
            text: el.name,
            type: el.type,
            assetName: el.name,
          };
        });
      }
    },
  },
  props: {
    showMediaBio: {
      type: String,
      default: "",
    },
    showAddBioBtn: {
      type: Boolean,
      default: false,
    },
    currentUser: {
      type: Object,
      default() {
        return {};
      },
    },
    personData: {
      type: Object,
      default() {
        return {};
      },
    },
    biographies: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  mounted() {
    if (
      !this.$route.path.includes("demo") &&
      this.currentUser.id == this.personData.userId
    ) {
      this.$store.dispatch("person/getMedia", this.$route.params.id);
    }
  },
  methods: {
    closeTimelineModal() {
      this.clearTimelineForm();
    },
    removeImage(ind) {
      this.currentBio.assets = this.currentBio.assets.filter(
        (el, index) => index !== ind
      );
    },
    addMedia() {
      this.currentBio.assets.push({});
    },
    saveDateStartMenu(date) {
      this.$refs.dateStartMenu.save(date);
    },
    getStartEndDates(start, end) {
      return `${moment(start).format("DD/MM/YYYY")} ${
        end ? "- " + moment(end).format("DD/MM/YYYY") : ""
      }`;
    },
    saveDateEndMenu(date) {
      this.$refs.dateEndMenu.save(date);
    },
    addTimelineModal() {
      this.timelineMode = "add";
      this.currentBio = {
        id: null,
        personId: "",
        userId: this.currentUser.id,
        from: "",
        to: "",
        title: "",
        description: "",
        assets: [],
      };
      this.dialogEditAdd = true;
    },
    clearTimelineForm() {
      this.currentBio = {
        id: null,
        personId: "",
        userId: "",
        from: "",
        to: "",
        title: "",
        description: "",
        assets: [],
      };
      this.dialogEditAdd = false;
      this.dialogDelete = null;
    },
    editTimelineModal(bio) {
      this.timelineMode = "edit";
      this.currentBio = { ...bio };

      // assetUrl
      // assetName
      // entityId
      // type

      this.dialogEditAdd = true;
    },
    manageTimeline() {
      var payload = { ...this.currentBio };
      payload.assets = payload.assets
        .filter((el) => el)
        .map((el) => {
          var current = this.images.find((img) => img.value === el.value);

          if (current) {
            current.entityId = current.value;
            return current;
          } else {
            current = this.images.find((img) => img.value === el);
            current.entityId = current.value;
            return current;
          }
        });

      if (this.currentBio.from && this.currentBio.title) {
        if (this.timelineMode === "edit") {
          this.$emit("editTimeline", payload);
        } else {
          this.$emit("addTimeline", payload);
        }
        this.clearTimelineForm();
      } else {
        this.$store.commit("toast", {
          message: this.lang.general.fillAllFields,
          color: "red lighten-2",
        });
      }
    },
    deleteTimelineModal(bio) {
      this.currentBio.id = bio.id;
      this.dialogDelete = true;
    },
    deleteTimeline() {
      this.$emit("deleteTimeline", this.currentBio.id);
      this.clearTimelineForm();
    },
  },
  watch: {
    dateStartMenu(val) {
      val &&
        setTimeout(() => {
          this.activePickerStart = "YEAR";
        }, 500);
    },
    dateEndMenu(val) {
      val &&
        setTimeout(() => {
          this.activePickerEnd = "YEAR";
        }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
#timeline .v-timeline-item__inner-dot {
  background: red !important;
  border-color: red !important;
}
.bio-title {
  font-size: 18px !important;
  font-style: italic;
  font-weight: 600;
}
.bio-text {
  font-size: 15px;
  color: #686868;
  font-style: italic;
}
.timeline-action-container {
  min-width: 82px;
  button:last-child {
    margin-left: 10px;
  }
}

@media only screen and (max-width: 1050px) {
  .timeline-action-container {
    min-width: 36px;
    width: 36px;
    button:last-child {
      margin-left: 0;
      margin-top: 10px;
    }
  }
  .v-timeline {
    margin-left: -30px;
  }
}

@media screen and (max-width: 600px) {
  .on-mobile {
    padding-top: 0 !important;
    margin-top: -5px;
  }
  .pl-m0 {
    padding-left: 0 !important;
  }
  .pt-1.mt-0 {
    margin-top: 0 !important;
  }
}
</style>